export default __webpack_public_path__ + "static/media/10.63a57042.png";